export default __webpack_public_path__ + "static/media/receiptemployee.826f6d3e.svg";